







































































































import _ from 'lodash'
import Vue from 'vue'
import axios from 'axios'
import { State, Mutation, Getter } from 'vuex-class'
import { MessageCommandProcessor, MediaCommandProcessor } from '@/api'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { EventUtils, Mobile, Misc } from '@/utils'
import mime from 'mime-types'
import { AppSettings } from '@/appSettings'
import MicRecorder from 'mic-recorder-to-mp3'
import * as uuid from 'uuid'

@Component
export default class MessageInput extends Vue {
  @State app
  @Getter botAccountData
  @Getter showAttachmentInput
  @Getter showRecordAudio

  @Prop({ type: Object, required: false })
  customSendMessage: object

  @Prop({ type: Boolean, required: true })
  isClientOffline: boolean = false

  @Prop({ type: String, required: false })
  culture: string = 'pt'

  @Prop ({ type: String, required: false })
  contentFilterRegex: string = ''

  @Mutation('setHasMessages') mutationHasMessages

  @Getter authenticadedMedias: boolean

  msgValue: string = ''
  msgType: string = 'text/plain'
  offlineAlertMsg: string = 'Você está offline'
  cancel: string = 'Cancelar'
  textAreaPlaceholder: string = 'Digite sua mensagem aqui'
  showBtn: boolean = false
  isUploading: boolean = false
  keepKeyboardOpenOnSendFile: boolean = false
  sendMsgBtnBackground: object = {}
  recordingAudio: boolean = false
  recordingSeconds: number = 0
  timerId: number | undefined
  timerString: string = '00:00'
  loadingAudioRecorder = false

  audioRecorder = new MicRecorder({
    bitRate: 128,
  })

  SendChatStateComposing = () => function(this) {
    const message = {
      type: 'application/vnd.lime.chatstate+json',
      content: { state: 'composing' },
    }
    MessageCommandProcessor.send(this.customSendMessage, message, false)
  }

  debounceSendChatStateComposing = _.debounce(
    this.SendChatStateComposing(),
    AppSettings.get('COMPOSING_DELAY'),
    { leading: true, trailing: false }
  ).bind(this)

  debounceSendChatStatePaused = _.debounce(
    function(this) {
      const message = {
        type: 'application/vnd.lime.chatstate+json',
        content: { state: 'paused' },
      }
      MessageCommandProcessor.send(this.customSendMessage, message, false)
    },
    AppSettings.get('COMPOSING_DELAY'),
    { leading: false, trailing: true }
  ).bind(this)

  @Watch('msgValue', { immediate: true, deep: true })
  onMsgChanged() {
    let hasMsgValue = this.msgValue !== '' ? true : false
    this.showBtn = hasMsgValue
    this.autosize()
    if (hasMsgValue) {
      this.debounceSendChatStateComposing()
      this.debounceSendChatStatePaused()
    }
  }

  @Watch('culture')
  evaluateString() {
    switch (true) {
      case this.culture.startsWith('pt'):
        this.offlineAlertMsg = 'Você está offline'
        this.textAreaPlaceholder = 'Digite sua mensagem aqui'
        this.cancel = 'Cancelar'
        break
      case this.culture.startsWith('es'):
        this.offlineAlertMsg = 'Sin conexión'
        this.textAreaPlaceholder = 'Escribe tu mensaje'
        this.cancel = 'Cancelar'
        break
      case this.culture.startsWith('en'):
      default:
        this.offlineAlertMsg = 'You are offline'
        this.textAreaPlaceholder = 'Enter your message here'
        this.cancel = 'Cancel'
        break
    }
  }

  get primaryColor() {
    return this.botAccountData.extras['blipchat-components-color']
  }

  mounted() {
    this.$parent.$on('sendMessage', (msg) => {
      this.sendValidMessage(msg, this.msgType)
      this.mutationHasMessages(true)
    })
    this.$parent.$on('setMessageType', (type) => {
      console.log('setMessageType', type)
      this.msgType = type
    })
  }

  beforeUnmount() {
    this.resetAudioRecording()
    this.audioRecorder.stop()
  }

  keyPressed(event) {
    if (event.keyCode === 13) {
      event.preventDefault()
      if (event.shiftKey || Mobile.isMobile()) {
        this.msgValue = this.msgValue.concat('\r')
        const textArea = document.getElementById('msg-textarea')
        if (textArea && textArea.scrollHeight >= 57) {
          setTimeout(() => {
            textArea.scrollTop = textArea.scrollHeight - textArea.clientHeight
            textArea.blur()
            textArea.focus()
          }, 50)
        }
      } else {
        this.onSendMessage(this.msgValue, this.msgType)
      }
    }
  }

  dispatchScrollEvent() {
    const messagesList = document.querySelector('.ss-content')
    if (messagesList) {
      let event
      if (typeof Event === 'function') {
        event = new Event('force-scroll')
      } else {
        event = document.createEvent('Event')
        event.initEvent('force-scroll', true, true)
      }
      messagesList.dispatchEvent(event)
    }
  }

  focusOnTextArea() {
    const textarea = document.getElementById('msg-textarea')
    if (textarea) {
      textarea.focus()
    }
  }

  onInputFile() {
    if (Mobile.isMobile() && Mobile.isKeyboardOpen()) {
      this.keepKeyboardOpenOnSendFile = true
    }
  }

  onSendMessage(msg, type) {
    if (Mobile.isMobile() && Mobile.isKeyboardOpen()) {
      this.focusOnTextArea()
    }

    if (typeof msg === 'string' && msg.trim() === '') {
      this.msgValue = ''

      return
    }

    this.sendValidMessage(msg, type)
  }

  sendValidMessage(msg, type) {
    if (
      type === 'application/vnd.lime.sensitive+json' &&
      (typeof msg === 'string' || msg instanceof String)
    ) {
      msg = {
        type: 'text/plain',
        value: msg
      }
    }

    if (this.contentFilterRegex !== '' && typeof msg === 'string') {
      const partesRegex = this.contentFilterRegex.split(';').map(r => r.trim()).filter(r => r.length > 0);
      partesRegex.forEach(pattern => {
        try {
          const regex = new RegExp(pattern, 'g');
          msg = msg.replace(regex, '**********');
        } catch (e) {
          console.error("Invalid regex pattern:", pattern, e);
        }
      });
    }

    const message = {
      type,
      content: msg,
      metadata: undefined,
    }

    if (
      type === 'application/vnd.lime.media-link+json'       
    ) {
      message.metadata = msg.metadata;

      if (this.authenticadedMedias) {
        message.content = {
          ...message.content,
          authorizationRealm: 'blip',
        };        
      }
    }

    this.dispatchScrollEvent()
    
    MessageCommandProcessor.send(this.customSendMessage, message)

    this.msgValue = ''
    this.msgType = 'text/plain'

    this.debounceSendChatStateComposing = _.debounce(
      this.SendChatStateComposing(),
      AppSettings.get('COMPOSING_DELAY'),
      { leading: true, trailing: false }
    ).bind(this)
  }

  async attachFile(files) {
    if (!files.length) {
      return
    }

    if (this.keepKeyboardOpenOnSendFile) {
      this.focusOnTextArea()
      this.keepKeyboardOpenOnSendFile = false
    }

    let fileList: any[] = []
    Array.from(Array(files.length).keys()).forEach((id) => {
      fileList = fileList.concat(files[id])
    })
    this.uploadFiles(fileList)
  }

  async uploadFiles(fileList: any[]) {
    this.isUploading = true
    const reader = new FileReader()
    reader.addEventListener('loadend', async (e: any) => {
      const validFile = await Misc.ValidFile({
        src: e.target.result,
        size: fileList[0].size,
        type: fileList[0].type,
      })
      if (!validFile) {
        this.isUploading = false
        const input = document.getElementById('uploadFile') as HTMLInputElement
        input.value = ''
        EventUtils.ShowError('Não foi possível carregar o arquivo.')

        return false
      }
      const mediaLinkDocument = {
        title: fileList[0].type.indexOf('image') !== -1 ? '' : fileList[0].name,
        type: fileList[0].type,
        size: fileList[0].size,
        metadata: fileList[0].metadata,
      }
      this.sendFileToUser(fileList[0], mediaLinkDocument)
      const splitList = fileList.splice(1)
      this.uploadFiles(splitList)
    })

    if (fileList[0]) {
      reader.readAsDataURL(fileList[0])
    }
  }

  async sendFileToUser(file, mediaLinkDocument) {
    try {
      const mediaPromise = this.uploadFileWithMediaApplication(file, mediaLinkDocument)

      mediaPromise.then((limeDocument) => {
          this.isUploading = false
          const input = document.getElementById('uploadFile') as HTMLInputElement
          input.value = ''

          this.onSendMessage(
            limeDocument,
            'application/vnd.lime.media-link+json'
          )
        })
        .catch((error) => {
          this.isUploading = false
          EventUtils.ShowError('Não foi possível carregar o arquivo.')
          console.error(error)
        })
    } catch (e) {
        EventUtils.ShowError('Não foi possível carregar o arquivo.')
        console.error(e)
        return
    }
  }

  autosize() {
    const textArea = document.getElementById('msg-textarea')
    const messageInput = document.getElementById('message-input')

    setTimeout(() => {
      if (textArea && messageInput) {
        textArea.style.cssText = 'height:auto; padding:0'
        textArea.style.cssText = 'height:' + textArea.scrollHeight + 'px'
        if (textArea.scrollHeight >= 57) {
          messageInput.style.height = textArea.scrollHeight < 69 ? '63px' : '69px'
          messageInput.scrollTop = messageInput.scrollHeight
          textArea.style.bottom = '0'
        } else {
          messageInput.style.height = '57px'
        }
      }
    }, 0)
  }

  private async uploadFileWithMediaApplication(file, mediaLinkDocument) {
    const mediaUploadUriResponse = this.authenticadedMedias 
      ? await MediaCommandProcessor.getMediaUploadAuthenticatedUri() 
      : await MediaCommandProcessor.getMediaUploadUri()

    if (!mediaUploadUriResponse || mediaUploadUriResponse.status !== 'success') {
      throw new Error(mediaUploadUriResponse.reason.description)
    }

    return axios
      .post(`${mediaUploadUriResponse.resource}?context=blipChat`, file, {
        headers: {
          'Content-Type': mime.contentType(file.name)
        },
      })
      .then(response => {
        return mediaLinkDocument = {
          ...mediaLinkDocument,
          uri: response.data.mediaUri,
        }
      })
  }

  async startAudioRecording() {
    try {
      this.loadingAudioRecorder = true
      await this.audioRecorder.start()
      this.recordingAudio = true
      this.loadingAudioRecorder = false
      this.startTimer()
    } catch (e: any) {
      this.handleAudioErrors(e)
      this.resetAudioRecording()
    }
  }

  async stopAndSendAudio() {
    try {
      this.recordingAudio = false
      this.stopTimer()
      const [_, blob] = await this.audioRecorder.stop().getMp3()
      const voiceBlob: any = new Blob([blob], { type: 'voice/mp3' });

      if (voiceBlob.size > 0) {
        voiceBlob.name = `${uuid.v4()}.mp3`
        voiceBlob.metadata = {
          '#blipChat.voice': true,
        }
        this.uploadFiles([voiceBlob])
      } else {
        EventUtils.ShowError('Áudio com duração muito pequena. Tente novamente por um tempo um pouco maior')
      }
      this.resetAudioRecording()
    } catch (e: any) {
      this.handleAudioErrors(e)
      this.resetAudioRecording()
    }
  }

  resetAudioRecording() {
    this.recordingAudio = false
    this.isUploading = false
    this.loadingAudioRecorder = false
    this.stopTimer()
  }

  async cancelAudioRecording() {
    this.audioRecorder.stop()
    this.resetAudioRecording()
  }

  async updateTimerString() {
    const minutes = Math.floor(this.recordingSeconds / 60)
    const seconds = this.recordingSeconds % 60
    this.timerString = `${minutes < 10 ? '0' + minutes : minutes}:${seconds < 10 ? '0' + seconds : seconds}`
  }

  async startTimer() {
    this.timerId = setInterval(() => {
      this.recordingSeconds++
      this.updateTimerString()
    }, 1000)
  }

  async stopTimer() {
    this.pauseTimer()
    this.recordingSeconds = 0
    this.updateTimerString()
  }

  async pauseTimer() {
    clearInterval(this.timerId)
  }

  async handleAudioErrors(e: Error) {
    if (!e || !e.message) {
      return
    }

    if (e.message.toLowerCase().includes('permission denied')) {
      EventUtils.ShowError('Permissão de microfone não habilitada. Por favor habilite e tente novamente.')
    } else {
      EventUtils.ShowError(e.message)
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MessageInput.vue